"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseOnboardingCommand = void 0;
const cq_core_1 = require("@leavy/cq-core");
const validator_1 = require("@leavy/validator");
const OnboardingId_1 = require("../domain/OnboardingId");
class BaseOnboardingCommand extends cq_core_1.Command {
}
__decorate([
    (0, validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], BaseOnboardingCommand.prototype, "userId", void 0);
__decorate([
    (0, validator_1.IsEnum)(OnboardingId_1.OnboardingId),
    __metadata("design:type", String)
], BaseOnboardingCommand.prototype, "onboardingId", void 0);
exports.BaseOnboardingCommand = BaseOnboardingCommand;
//# sourceMappingURL=BaseOnboardingCommand.js.map